// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LandingPage-code-viewer__lang-selector {
  position: relative;
}

.lang-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.dropdown-menu {
  width: inherit;
  position: absolute;
  top: 0;
  background-color: #ffffff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  border: none;
  text-align: center;
}

.dropdown-menu > button {
  border: none;
  width: 100%;
  text-align: center;
}

.dropdown-menu > button span {
  color: #000;
}

.dropdown-menu > button:first-of-type {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

.dropdown-menu > button:last-of-type {
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

.dropdown-menu > button:hover {
  background-color: #dfdfdf;
}

/***************
  * CODE EDITOR *
  ***************/
.code-editor {
  color: #d4d4d4;
  font-family: Menlo;
  font-weight: 500;
}

.code-editor__line {
  margin-left: 1.2rem;
  text-indent: -1.2rem;
}

.code-editor__text--line-number {
  color: #5a5a5a;
}

.code-editor__text--reserved {
  color: #569cd6;
}

.code-editor__text--comment {
  color: #608b4e;
}

.code-editor__text--string {
  color: #ce9178;
}

.code-editor__tab::after {
  content: '\\a0\\a0\\a0\\a0';
  color: #5a5a5a;
  border-left: 1.2px solid #5a5a5a;
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/Common/CodeViewer.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,yBAAyB;EACzB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;iBAEiB;AACjB;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC","sourcesContent":[".LandingPage-code-viewer__lang-selector {\n  position: relative;\n}\n\n.lang-btn{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.dropdown-menu {\n  width: inherit;\n  position: absolute;\n  top: 0;\n  background-color: #ffffff;\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n  border: none;\n  text-align: center;\n}\n\n.dropdown-menu > button {\n  border: none;\n  width: 100%;\n  text-align: center;\n}\n\n.dropdown-menu > button span {\n  color: #000;\n}\n\n.dropdown-menu > button:first-of-type {\n  border-top-left-radius: 20px;\n  border-top-right-radius: 20px;\n}\n\n.dropdown-menu > button:last-of-type {\n  border-bottom-left-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n\n.dropdown-menu > button:hover {\n  background-color: #dfdfdf;\n}\n\n/***************\n  * CODE EDITOR *\n  ***************/\n.code-editor {\n  color: #d4d4d4;\n  font-family: Menlo;\n  font-weight: 500;\n}\n\n.code-editor__line {\n  margin-left: 1.2rem;\n  text-indent: -1.2rem;\n}\n\n.code-editor__text--line-number {\n  color: #5a5a5a;\n}\n\n.code-editor__text--reserved {\n  color: #569cd6;\n}\n\n.code-editor__text--comment {\n  color: #608b4e;\n}\n\n.code-editor__text--string {\n  color: #ce9178;\n}\n\n.code-editor__tab::after {\n  content: '\\a0\\a0\\a0\\a0';\n  color: #5a5a5a;\n  border-left: 1.2px solid #5a5a5a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
